module.exports = "data:text/x-markdown;base64,VGhpcyBpcyBhIHNpbXBsZSB3YWxsZXQgdGhhdCBkcmlwcyBmdW5kcyBvdmVyIHRpbWUuIFlvdSBjYW4gd2l0aGRyYXcgdGhlIGZ1bmRzCnNsb3dseSBieSBiZWNvbWluZyBhIHdpdGhkcmF3aW5nIHBhcnRuZXIuCgpJZiB5b3UgY2FuIGRlbnkgdGhlIG93bmVyIGZyb20gd2l0aGRyYXdpbmcgZnVuZHMgd2hlbiB0aGV5IGNhbGwgYHdpdGhkcmF3KClgCih3aGlsc3QgdGhlIGNvbnRyYWN0IHN0aWxsIGhhcyBmdW5kcykgeW91IHdpbGwgd2luIHRoaXMgbGV2ZWwuCg=="


//////////////////
// WEBPACK FOOTER
// ./gamedata/descriptions/levels/denial.md
// module id = 1363
// module chunks = 0